module.exports = __webpack_public_path__ + "assets/img/projects_item2.7b94cbcd.png";